import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { RCL } from "../../components/RCL";
import { convertNumber, convertCurrency } from "../../helpers/helper";
import { Button as ButtonComponent } from "@sunwing/components/dist/Button";
import { Img } from "@sunwing/shared-components";
import { Icon, Heading, Section } from "@sunwing/components";
import cx from "classnames";
import styles from "./StarCard.module.scss";
import { StringResources } from "../../components/StringResources";

const StarCard = ({ locale, starCardInfo }) => {

  return (
    <Section padding="bottom">
      <div className={cx(styles.starCard, styles.starCardRegistered)}>
        <div className={styles.starCardHeading}>
          <div className={styles.starCardImage}>
            <Img
              src={ StringResources({searchKey: "star-card-image"}) }
              alt="Star Card"
            />
          </div>
          <Heading as="h4">
            <RCL searchKey="yourStarCard" />
          </Heading>
        </div>
        <div className={styles.starCardBalance}>
          <div className={styles.starCardBalanceItem}>
            <p>
              <RCL searchKey="totalPointsEarned" />
            </p>
            <Heading size="h3" as="p">
              {starCardInfo != null &&
                convertNumber(starCardInfo.totalPtnsEarned, locale)}
            </Heading>
          </div>
          <div className={styles.starCardBalanceItem}>
            <p>
              <RCL searchKey="totalPointsUsed" />
            </p>
            <Heading size="h3" as="p">
              {starCardInfo != null &&
                convertNumber(starCardInfo.totalPtnsUsed, locale)}
            </Heading>
          </div>
          <div className={styles.starCardBalanceItem}>
            <p>
              <RCL searchKey="currentPointsBalance" />
            </p>
            <Heading size="h3" as="p">
              {starCardInfo != null &&
                convertNumber(
                  (starCardInfo.totalPtnsEarned) - (starCardInfo.totalPtnsUsed),
                  locale
                )}
            </Heading>
          </div>
          <div className={styles.starCardBalanceItem}>
            <p>
              <Icon
                name="budget"
                className={cx(styles.highlighted, styles.budget)}
              />
              <RCL searchKey="starCashBalance" />
            </p>
            <Heading size="h3" as="p">
              <span className={styles.highlighted}>
                {starCardInfo != null &&
                  convertCurrency(starCardInfo?.starCashBal, locale)}
              </span>
            </Heading>
          </div>
        </div>
        <div className={styles.starCardCtas}>
          <ButtonComponent
            key="seepromotion"
            className={cx("button")}
            to={`/${locale === "fr" ? "fr" : "en"}/flyers`}
          >
            <RCL searchKey="STAR_seepromotion" />
          </ButtonComponent>
        </div>
      </div>
    </Section>
  );
};

export default StarCard;
export { StarCard };
